import { Colors, ProgressBar, Typography } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { abbreviateNumber } from './abbreviateNumber';
const Styles = labelStyles('UsageBar', {
    root: {
        display: 'block',
        paddingTop: '10px',
    },
    text: {
        display: 'grid',
        gap: 20,
        gridTemplateColumns: 'auto 1fr',
        marginBottom: 5,
    },
    label: Object.assign(Object.assign({}, Typography.smallPrint1Semibold), { color: Colors.neutral700 }),
    amounts: Object.assign(Object.assign({}, Typography.smallPrint1Medium), { textAlign: 'right', color: Colors.neutral700 }),
});
const formatNumber = (number) => {
    const formatted = number > 9999 ? abbreviateNumber(number) : number.toLocaleString();
    return typeof formatted === 'string' ? formatted : 'Error';
};
const UsageBar = (props) => {
    const amount = props.max === Infinity
        ? 'Unlimited'
        : `${formatNumber(props.value)} / ${formatNumber(props.max)}`;
    return (isolateComponent("figure", { css: Styles.root },
        isolateComponent("p", { "aria-label": `Used ${props.value} of ${props.max} ${props.label}`, css: Styles.text },
            isolateComponent("span", { "aria-hidden": true, css: Styles.label }, props.label),
            isolateComponent("span", { "aria-hidden": true, css: Styles.amounts }, amount)),
        props.max !== Infinity && (isolateComponent(ProgressBar, { max: props.max, value: props.value }))));
};
export default UsageBar;
//# sourceMappingURL=UsageBar.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
